import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";

@Component({
    selector: "send-evaluation-dialog",
    templateUrl: "send-evaluation-dialog.component.html",
    styleUrls: ["send-evaluation-dialog.component.scss"],
    standalone: false
})
export class SendEvaluationComponent {
    constructor(@Inject(MAT_DIALOG_DATA) public data: any) {}

    confirm() {
        this.data.confirm();
    }

    close() {
        this.data.close();
    }
}
